import React, { Fragment, useEffect, useRef } from 'react';
import ReactAudioPlayer from 'react-audio-player';

import eventsService from '../../services/events.service';

export default (props) => {

  const playerRef = useRef(null);

  useEffect(() => {
    addEventListener(eventsService.AUDIO_PLAYER_START,
      ohterPlayerPlayHandler);
    return () => {
      removeEventListener(eventsService.AUDIO_PLAYER_START,
        ohterPlayerPlayHandler);
    };
  });

  const playHandler = (event) => {
    eventsService.dispatch(eventsService.AUDIO_PLAYER_START,
      playerRef.current.audioEl.current);
  };

  const ohterPlayerPlayHandler = (event) => {
    if (event.target !== playerRef.current.audioEl.current) {
      playerRef.current.audioEl.current.pause();
    }
  };

  return (
    <Fragment>
      <div className="col col-player" data-audio-id={props.audioId}>
        <ReactAudioPlayer
          ref={playerRef}
          src={props.src}
          controls
          onPlay={playHandler}
          />
      </div>
    </Fragment>
  );
}
